export default "__VITE_ASSET__BBMkA_9w__"